// Implements: F-UIX-025
/**
 * Money as text, from the integer micros the API speaks (DD14).
 *
 * Up to six decimals are kept: a price ceiling of 0.0004 USD rounded to
 * "0.00" would tell somebody a paid step is free. A currency code the platform
 * does not know (`Intl` throws `RangeError`) is shown as the plain amount and
 * the code, never as an exception in the middle of a dialog. It is written in the platform locale
 * ("USD 1,000.50"), never the browser's (`types/locale.ts`, 7.S12b-4.6).
 */

import { PLATFORM_LOCALE } from "../../types/locale";

const MICROS_PER_UNIT = 1_000_000;

export function moneyText(amountMicros: number, currency: string): string {
  const amount = amountMicros / MICROS_PER_UNIT;
  try {
    return new Intl.NumberFormat(PLATFORM_LOCALE, {
      style: "currency",
      currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 6,
    }).format(amount);
  } catch {
    return `${String(amount)} ${currency}`;
  }
}
